<template>
    <li
        class="question-item"
        :class="
            !question.option_type || question.option_type === 'single'
                ? ''
                : 'checkbox'
        "
    >
        <p
            v-if="question.option_type && question.option_type !== 'single'"
            class="checkbox-sign"
        >
            多选
        </p>
        <p>
            <slot name="queIndex" />
            {{ question.description }}
        </p>
        <div class="images">
            <my-image
                class="que-image"
                v-if="question.image_description"
                :src="question.image_description"
                ref="itemImage"
            />
        </div>

        <RadioGroup
            v-if="!question.option_type || question.option_type === 'single'"
            :value="val.seq_id"
            :class="`question-options ${
                question.answer_type === 'text' ? '' : 'image-option'
            }`"
        >
            <Radio
                v-for="(item, index) in question.answers"
                :key="index"
                :name="item.seq_id"
                :class="`option ${disabled ? 'disabled' : ''}`"
                @click="() => onChange(item.seq_id)"
            >
                <template #icon="props">
                    <slot name="icon" :data="{ ...props, seq_id: item.seq_id }">
                        <i
                            :class="`radio-icon-round ${
                                props.checked ? 'active' : ''
                            }`"
                        />
                    </slot>
                </template>
                <span>{{ ["A", "B", "C", "D"][index] }}.</span>
                <span>{{ item.description }}</span>
                <my-image
                    v-if="item.image_description"
                    class="que-image"
                    :src="item.image_description"
                    ref="itemImage"
                />
            </Radio>
        </RadioGroup>

        <CheckboxGroup
            v-else
            :value="val.multi_answer_seq_num"
            :class="`question-options ${
                question.answer_type === 'text' ? '' : 'image-option'
            }`"
        >
            <Checkbox
                v-for="(item, index) in question.answers"
                :key="index"
                :name="item.seq_id"
                :class="`option ${disabled ? 'disabled' : ''}`"
                @click="() => onChange(item.seq_id)"
            >
                <template #icon="props">
                    <slot name="icon" :data="{ ...props, seq_id: item.seq_id }">
                        <i
                            :class="`radio-icon-round ${
                                props.checked ? 'active' : ''
                            }`"
                        />
                    </slot>
                </template>
                <span>{{ ["A", "B", "C", "D"][index] }}.</span>
                <span>{{ item.description }}</span>
                <my-image
                    v-if="item.image_description"
                    class="que-image"
                    ref="itemImage"
                    :src="item.image_description"
                />
            </Checkbox>
        </CheckboxGroup>
    </li>
</template>

<script>
import { RadioGroup, Radio, CheckboxGroup, Checkbox } from "vant";
export default {
    name: "Question",
    props: {
        question: {
            type: Object,
            default: function () {
                return {};
            },
        },
        val: {
            type: Object,
            default: function () {
                return {
                    seq_id: "",
                    multi_answer_seq_num: [],
                };
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        RadioGroup,
        Radio,
        CheckboxGroup,
        Checkbox,
    },
    watch: {
        question: {
            handler: function () {
                this.$nextTick(() => {
                    this.$refs.itemImage?.forEach((item) => {
                        item && item.hide();
                    });
                });
            },
            deep: true,
        },
    },
    methods: {
        previewImg(e, url) {
            this.$hevueImgPreview(url);
            e.stopPropagation();
        },
        onChange(val) {
            if (this.disabled) return;
            if (
                !this.question.option_type ||
                this.question.option_type === "single"
            ) {
                this.$emit("update:val", {
                    seq_id: val,
                    score: this.question.score,
                    quiz_id: this.question.quiz_id,
                });
            } else {
                let mSeqId = this.val.multi_answer_seq_num || [];
                const valIndex = mSeqId.indexOf(val);
                if (valIndex < 0) {
                    mSeqId = [...mSeqId, val];
                } else {
                    mSeqId.splice(valIndex, 1);
                }
                this.$emit("update:val", {
                    multi_answer_seq_num: [...mSeqId],
                    score: this.question.score,
                    quiz_id: this.question.quiz_id,
                });
            }
        },
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.question-item {
    /deep/ .mint-cell-wrapper {
        padding: 0;
    }
    .checkbox-sign {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0 1rem;
        background: #ffc700;
        border-radius: 0 0 10px 0;
    }
    p {
        margin: 0;
        padding: 0;
        font-weight: bold;
        font-size: 1.5rem;
        color: #082754;
        line-height: 1.6em;
    }
    .que-image {
        display: block;
        margin: auto;
        max-width: 100%;
        max-height: 30vh;
    }

    .question-options {
        &.image-option {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .option {
                width: 50%;
                .que-image {
                    max-height: 15vh;
                }
            }
        }
    }
    /deep/.van-radio-group,
    /deep/.van-checkbox-group {
        margin-top: 2.1rem;
        .van-checkbox,
        .van-radio {
            align-items: flex-start;
            padding: 0;
            margin-bottom: 2.1rem;
            &.disabled {
                .van-radio__label {
                    color: #c8c9cc;
                }
                .radio-icon-round {
                    background-color: #ebedf0;
                    border-color: #c8c9cc;
                    &::before {
                        background: #c8c9cc;
                    }
                }
            }
        }
        .van-radio__icon {
            height: auto;
        }
        .van-radio__label,
        .van-checkbox__label {
            font-size: 14px;
            line-height: 1.6em;
            color: #082754;
            margin-left: 0;
        }
    }

    /deep/.radio-icon-round {
        display: block;
        margin-top: 0.3rem;
        margin-right: 0.5rem;
        width: 14px;
        height: 14px;
        border-radius: 100%;
        border: 1px #bcbcbc solid;
        &.active {
            position: relative;
            &::before {
                content: "";
                position: absolute;
                width: 0.75rem;
                height: 0.75rem;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: #123e7f;
                border-radius: 100%;
            }
        }
    }

    &.checkbox {
        padding-top: 1rem;
        /deep/.radio-icon-round {
            border-radius: 0;
            &.active {
                &::before {
                    border-radius: 0;
                }
            }
        }
    }
}
</style>

<style lang="less">
.question-item{
    .que-image {
        .viewer {
            max-width: 100%;
            max-height: 30vh;
            img {
                width: auto;
                max-height: 30vh;
            }
        }
    }   
    .option {
        .icon {
            width: 15px;
            height: 15px;
            border-radius: 50%;
        }
        .que-image {
            .viewer {
                max-width: 100%;
                max-height: 15vh;
                img {
                    width: auto;
                    max-height: 15vh;
                }
            }
        }
    }
}

.checkbox {
    .option {
        .icon {
            border-radius: 0%;
        }
    }
}
</style>